@if (isLoading()) {
  <elcia-loader/>
} @else {
  <p-table [scrollable]="true" [size]="'small'" [value]="rows()" scrollHeight="flex" stripedRows>
    <ng-template #header>
      <tr>
        <th>{{ 'entity.user' | translate }}</th>
        @for (permission of permissions(); track permission) {
          <th class="text-center whitespace-nowrap">{{ permission | permissionLabel }}</th>
        }
      </tr>
    </ng-template>
    <ng-template #body let-row>
      <tr [class.opacity-60]="row.isCurrentUser">
        <td class="whitespace-nowrap">{{ row.fullName }}</td>
        @for (permission of permissions(); track permission) {
          <td class="text-center">
            <p-checkbox
              [binary]="true"
              [disabled]="row.isCurrentUser"
              [ngModel]="has(row, permission)"
              (onChange)="toggle(row, permission)"/>
          </td>
        }
      </tr>
    </ng-template>
  </p-table>
}
